/*
 * @Description: Description
 * @Autor: Chen
 * @Date: 2021-03-03 09:03:41
 * @LastEditors: chen
 * @LastEditTime: 2021-05-19 14:24:16
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'score'
})
export class ScorePipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    if (!value || value <= 0) {
      return '-';
    }
    return value;
  }

}
